import { createFileRoute } from "@tanstack/react-router";
import { PostEditor } from "@/components/admin/PostEditor";

export const Route = createFileRoute("/_authenticated/admin/new")({
  component: () => (
    <div>
      <h1 className="headline-md mb-6">New post</h1>
      <PostEditor />
    </div>
  ),
});
